/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetContextAttributeNamesPathParams = NonNullable<
  operations['getContextAttributeNames']['parameters']['path']
>;

export type GetContextAttributeNamesQueryParams = NonNullable<
  operations['getContextAttributeNames']['parameters']['query']
>;

export interface Input extends GetContextAttributeNamesPathParams {
  apiVersion?: string;
  query?: GetContextAttributeNamesQueryParams;
}

export async function getContextAttributeNames(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/projects/{projectKey}/environments/{environmentKey}/context-attributes', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
